import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Modal, Select, Button } from 'antd';
import useApi from 'vl-common/src/hooks/useApi';
import { useQuery } from '@tanstack/react-query';

interface Props {
  show: boolean;
  onClose: () => void;
  onSubmit: (cancel_code: string) => void;
}

const CancelRequestModal = ({ show, onClose, onSubmit }: Props) => {
  const { t } = useTranslation('common');
  const { Api } = useApi();
  const [selectedItem, setSelectedItem] = useState<string | null>(null);
  const isSelected = selectedItem !== null && selectedItem !== undefined && selectedItem !== '';

  const {
    data: requestStatusCancelOptions = [],
    isLoading: requestStatusCancelOptionsIsLoading,
    isError
  } = useQuery({
    queryKey: ['metaInvreq'],
    queryFn: async () => {
      const response = await Api.meta.getInvreqMeta();
      return response;
    }
  });

  useEffect(() => {
    if (show) {
      setSelectedItem(null);
    }
  }, [show]);

  return (
    <Modal
      title={'Cancel Request'}
      open={show}
      onCancel={onClose}
      onOk={() => {
        if (selectedItem) {
          onSubmit(selectedItem);
        }
      }}
      data-testid={'cancel-request-modal'}
      okButtonProps={{ disabled: !isSelected }}
      footer={[
        <Button data-testid={'cancel-cancel-request-modal'} key="cancel" onClick={onClose}>
          {t('Cancel')}
        </Button>,
        <Button
          key="submit"
          type="primary"
          onClick={() => {
            if (selectedItem) {
              onSubmit(selectedItem);
            }
          }}
          data-testid={'submit-cancel-request-modal'}
          disabled={!isSelected}
        >
          {t('Cancel')}
        </Button>
      ]}
    >
      <label htmlFor="cancel-request-select" style={{ fontSize: '14px' }}>
        {t('Please select a reason why you are cancelling the request')}
      </label>
      {requestStatusCancelOptionsIsLoading || isError ? (
        <p>{t('Loading...')}</p>
      ) : (
        <Select
          id="cancel-request-select"
          value={selectedItem}
          data-testid={'cancel-request-select'}
          placeholder={t('Select from dropdown')}
          style={{ width: '100%' }}
          loading={requestStatusCancelOptionsIsLoading}
          onChange={(value) => setSelectedItem(value)}
        >
          {requestStatusCancelOptions?.data?.meta[0]?.ireq_cancel_codes.map(
            (cancelCode: { ireq_cancel_code: string; ireq_cancel_desc: string }) => (
              <Select.Option key={cancelCode.ireq_cancel_code} value={cancelCode.ireq_cancel_code}>
                {cancelCode.ireq_cancel_desc}
              </Select.Option>
            )
          )}
        </Select>
      )}
    </Modal>
  );
};

export default CancelRequestModal;
